import { useState, useEffect, useMemo } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  TextField,
} from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const EditCycleModal = ({
  testCases,
  dropdownElInfo,
  editCycleOpen,
  setEditCycleOpen,
  setTestCasesToggler
}) => {
  const [selectedVersion, setSelectedVersion] = useState(null)
  const [cycleName, setCycleName] = useState('')
  const [cycleNameError, setCycleNameError] = useState('')
  const [cycleVersion, setCycleVersion] = useState('')
  const [loading, setLoading] = useState(false)

  const availableVersions = useMemo(() => {
    return testCases.filter(v => v.type !== 'general').map(v => ({ id: v.id, name: v.name }))
  }, [testCases])

  const currentVersion = testCases.find(v =>
    v.cycles.some(c => c.id === dropdownElInfo.id)
  ) || testCases.find(v => v.id === dropdownElInfo.versionId)
  const currentCycle = currentVersion?.cycles.find(
    (c) => c.id === dropdownElInfo.id
  ) || currentVersion?.cycles.find(
    (c) => c.id === dropdownElInfo.cycleId
  )

  useEffect(() => {
    if (editCycleOpen) {
      setSelectedVersion(currentVersion)
      setCycleName(dropdownElInfo.name)

      setCycleNameError('')
      setCycleVersion(currentCycle?.version_tag || '')
    }
  }, [editCycleOpen, dropdownElInfo, availableVersions, currentVersion, currentCycle])


  const handleCloseCreateDialog = () => {
    setEditCycleOpen(false)
    setSelectedVersion(null)
    setCycleNameError('')
    setCycleVersion('')
  }

  const handleCycleNameChange = (e) => {
    setCycleName(e.target.value)
    if (cycleNameError && e.target.value.trim()) {
      setCycleNameError('')
    }
  }



  const handleCreateCycle = async () => {
    let hasError = false

    if (!cycleName.trim()) {
      setCycleNameError('Cycle Name is required.')
      hasError = true
    } else {
      setCycleNameError('')
    }

    if (hasError) {
      return
    }

    try {
      setLoading(true)
      await PageService.updateTestCaseCycle(dropdownElInfo.id, {
        projectVersionId: selectedVersion.id,
        name: cycleName,
        description: '',
        versionTag: cycleVersion,
        dateFrom: null,
        dateTo: null,
      })
      setTestCasesToggler((prev) => !prev)
      handleCloseCreateDialog()
    } catch (error) {
      if (error?.response?.status === 409) {
        setCycleNameError(error.response.data?.error || 'A cycle with this name already exists in this version. Please choose a different name.')
      } else {
        console.log(error)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={editCycleOpen} onClose={handleCloseCreateDialog}>
      <Box className="createTestCaseCycleModal">
        <DialogTitle className="createTestCaseCycleModalTitle">
          Edit Cycle
        </DialogTitle>
        <DialogContent className="createTestCaseCycleModalContent">
          <TextField
            label="Cycle Name*"
            type="text"
            fullWidth
            variant="outlined"
            value={cycleName}
            onChange={handleCycleNameChange}
            error={!!cycleNameError}
            helperText={cycleNameError + ' '}
            inputProps={{ maxLength: 50 }}
            sx={{ mb: '4px' }}
          />

        </DialogContent>
        <DialogActions className="createTestCaseCycleModalActions">
          <Button className="createTestCaseCycleModalButton" onClick={handleCloseCreateDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="createTestCaseCycleModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="createTestCaseCycleModalButton" onClick={handleCreateCycle} color="secondary" variant="contained" autoFocus>
              SAVE
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default EditCycleModal
